import { Component, ViewChild,OnInit } from '@angular/core';
import { BottomSheet } from '../bottom.sheet';
import { AuthService } from '../auth.service';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { HandlerService } from '../handler.service';
import { Platform } from '@angular/cdk/platform';
import { MatTableDataSource} from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ExcelService } from '../excel.service';
import { FormControl } from '@angular/forms';
let k=1;

@Component({
  selector: 'app-manage-purchase',
  templateUrl: './manage-purchase.component.html',
  styleUrls: ['./manage-purchase.component.scss'],
})
export class ManagePurchaseComponent {
  @ViewChild(MatSort) sort: MatSort;
  displayedColumns = ['id','custName','place','region','service','payment','status'];
  dataSource: any; 
  orderItems:any=[];
  cancelledReasons;  
  cancelId;
  cancellation;
  confirm:boolean=false;
  check: boolean = false;
  send: boolean = false;
  rescheduleOrd: boolean = false;
  minDate = new Date();
  availableSlots=[];
  vendor;
  orderId;
  startdate;
  date=new Date();
  dateFormat;
  excelDataAll:any=[];
  excell:any=[];
  search:any=[];
  category;
  openPop:boolean=false;
  itemOrders:any=[];
  Cview: boolean = true;
  loader:boolean=false;
  allocationOptions:any;
  optionName;
  optionId;
  filterPop:boolean=false;
  searchShow:boolean=true;
  contDrop:boolean=false;
  orgs;
  orgName;
  orgId ;
  paymentName;
  paymentId;
  payment = [ { id: 2, name: "Paid" }, { id: 1, name: "Not Paid" }]
  statusObj = [{ id:7 , name: "Pending" }, 
  { id: 9, name: "Assigned" },
  { id: 2, name: "Shipped" },  
  { id: 4, name: "Delivered" },
  { id: 6, name: "Returned" },
  { id: 12, name: "Allocated" },
  { id: 5, name: "Cancelled" } 
 ]
  statusName;
  statusId;
  cateName;
  cateId;
  contractors;
  cate1Id;
  active1: boolean = false;
  contractorId;
  ContractorName;
  filter:boolean ;
  serviceFlat;
  custName;
  categoryName;
  reqStatusName;
  payStatusName;
  time = "Time";
  availSlot:boolean;
slotClicked:boolean;
serviceCategoryId;
openSlot:boolean = false;
  idFilter = new FormControl('');
  paymentStatusFilter =new FormControl('');
  categoryNameFilter= new FormControl('');
  serviceRegionFilter = new FormControl('');
  serviceFlatFilter = new FormControl(''); 
  custNameFilter = new FormControl('');
  statusFilter = new FormControl('');
  filterValues = {    
    id: '',
    serviceFlat: '', 
    categoryName: '', 
    delRegion:'',
    custName: '',
    payStatusName:'',
    reqStatusName:''

  };
   mbv:boolean;
  notifyItems: any = [];
  openPopUp:boolean = false;
message:any;
filterLength;
fDate;
slots;
slot;
Oid;
endTime;
slotDate;
serviceCategory;
  constructor(public auth: AuthService, private router: Router, public handler: HandlerService,
    public service: ApiService, private bottomSheet: MatBottomSheet, public platform: Platform, private excelService: ExcelService) { }

    ionViewWillEnter(){  
      this.loader=true; 
      sessionStorage.clear(); 
      this.dateFormat = this.auth.getDateformat();
      this.Oid=localStorage.getItem('organizationId')
      sessionStorage.setItem('vendorApp','true');
      this.getServiceCategory();
      this.idFilter.valueChanges
      .subscribe(
        id => {
          this.filterValues.id = id;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
      this.paymentStatusFilter.valueChanges
      .subscribe(
        payStatusName => {
          this.filterValues.payStatusName = payStatusName;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
      this.statusFilter.valueChanges
      .subscribe(
        reqStatusName => {
          this.filterValues.reqStatusName = reqStatusName;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
      this.categoryNameFilter.valueChanges
      .subscribe(
        categoryName => {
          this.filterValues.categoryName = categoryName;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
      this.serviceRegionFilter.valueChanges
      .subscribe(
        delRegion => {
          this.filterValues.delRegion = delRegion;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
      this.serviceFlatFilter.valueChanges
      .subscribe(
        serviceFlat => {
          this.filterValues.serviceFlat = serviceFlat;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
      this.custNameFilter.valueChanges
      .subscribe(
        custName => {
          this.filterValues.custName = custName;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
      this.dateFormat = this.auth.getDateformat();
      if (this.platform.ANDROID || this.platform.IOS) {
        this.mbv=false;
       }
       else{
         this.mbv=true;
       }
      this.getCategory();
      this.getOrgs();
      this.getCancelReason();
    }
serviceCateId

    getServiceCategory() {
      this.service.getOrgCategory().subscribe((res: any) => {
        this.serviceCategory = res;
        this.serviceCategory = this.serviceCategory.filter(res=>{ return res.code=="HOMEDEL"})
        this.serviceCategory.map(dat=>{
          this.serviceCategoryId=dat.id;
        })
     
      })
    }

    returnDate(data) {
      let date = data.getDate();
      date = date < 10 ? '0' + date : date;
     let month = data.getMonth() + 1;
     month = month < 10 ? '0' + month : month;
     let year = data.getFullYear();
     return year + '-' + month + '-' + date; 
    }

    returnDate1(data) {
      let date = data.getDate();
      date = date < 10 ? '0' + date : date;
     let month = data.getMonth() + 1;
     month = month < 10 ? '0' + month : month;
     let year = data.getFullYear();  
     return date + '-' + month + '-' + year;
   }

   next() {
    let x = new Date(JSON.parse(JSON.stringify(this.date)));
    let newDate = new Date(x.setDate(x.getDate() + 1));
    this.date = newDate;
    k=1;
    this.getAllOrder(this.date) 
  }
  
  prev() {  
    let x = new Date(JSON.parse(JSON.stringify(this.date)));
    let newDate = new Date(x.setDate(x.getDate() - 1));
    this.date = newDate
    k=1;
    this.getAllOrder(this.date)
  }


    getCategory() {
      this.service.getAllDetailedPurchaseCategory().subscribe((res: any) => {
        this.category = res;
        this.getAllOrder(this.date);
      })
    }

    getOrgs(){
      this.service.getOrg().subscribe((res:any)=>{
        this.orgs=res;    
      })
    }


    ngDoCheck(): void {
      this.filterLength = sessionStorage.getItem('len')
      
    }
    getsc(){
      this.loader = true;
      this.filterPop = false;   
      this.service.getUsersByOrg('SC',this.orgId,null).subscribe((res:any) => { 
        if(res){
          this.contractors=res;
        this.contractors.map(res=>{
          if(res.categoryLists)
          res.categoryLists.map(res1=>{     
           if(res1.categoryId == this.serviceCategoryId){
           this.cate1Id = res1.categoryId
           Object.assign(res,{vId:this.cate1Id})      
           }
          })
        })
        this.contractors= this.contractors.filter(res =>{return res.reqRoleApproved==true && res.vId==this.serviceCategoryId});
      // this.contractors= res.filter(res =>{return res.reqRoleApproved == true});
      this.loader = false;
      this.filterPop = true;
        }else{
          this.loader=false;
         this.contractors=[];
         this.filterPop = true;
         
        }
  },err=>{
    this.handler.err(err)
  })
  }
  

  getAllOrder(date) {
    this.loader=true;
    k=1;
    this.service.getAllOrderByType(this.returnDate(date),k).subscribe((res: any) => {
      if(res){
      this.orderItems = res;
      this.orderItems = this.orderItems.filter(res=>{ return (res.status==7 || res.status==2|| res.status==4|| res.status==5|| res.status==6|| res.status==9||res.status==12) && res.orderType==2})
      this.orderItems.map(res => {
        Object.assign(res, { clicked: false })
      })  
      this.orderItems.map(dat=>{
       this.category.map(dat1=>{
         if(dat.categoryId==dat1.id)
         Object.assign(dat, {categoryName: dat1.name})   
       })
       if(dat.paymtStatus==1)
       Object.assign(dat, {payStatusName: "Not Paid"})
       if(dat.paymtStatus==2)
       Object.assign(dat, {payStatusName: "Paid"})    
       if(dat.status==7)
       Object.assign(dat, {reqStatusName:"Pending"})  
       if(dat.status==11)
       Object.assign(dat, {reqStatusName:"Partially Delivered"}) 
       if(dat.status==2)
       Object.assign(dat, {reqStatusName:"Shipped"})
       if(dat.status==5)
       Object.assign(dat, {reqStatusName:"Cancelled"})
       if(dat.status==6)
       Object.assign(dat, {reqStatusName:"Returned"})   
       if(dat.status==9)
       Object.assign(dat, {reqStatusName:"Assigned"})
       if(dat.status==4)
       Object.assign(dat, {reqStatusName:"Delivered"})
       if(dat.status==12)
       Object.assign(dat, {reqStatusName:"Allocated"})
       if(dat.appt==true)
       Object.assign(dat, {serviceFlat:dat.flatName})
       if(dat.appt==false)
       Object.assign(dat, {serviceFlat:dat.street})
       if(dat.appt=="" || dat.appt== undefined )
       Object.assign(dat, {serviceFlat:"Not Specified"})
      })
      
      this.dataSource = new MatTableDataSource(this.orderItems); 
      this.dataSource.filterPredicate = this.createFilter(); 
      this.dataSource.sort = this.sort;
      this.loader=false; 
      k++;
    } else{
      this.loader=false;
      this.handler.res('No Data For You ')


    } 
    }) 
}

createFilter(): (data: any, filter: string) => boolean {
  let filterFunction = function(data, filter): boolean {
    let searchTerms = JSON.parse(filter);
    return data.id.toString().toLowerCase().indexOf(searchTerms.id) !== -1  
    && data.custName.toString().toLowerCase().indexOf(searchTerms.custName) !== -1
    && data.serviceName.toString().toLowerCase().indexOf(searchTerms.categoryName) !== -1   
    && data.serviceRegion.toString().toLowerCase().indexOf(searchTerms.delRegion) !== -1   
    // && data.serviceFlat.toString().toLowerCase().indexOf(searchTerms.serviceFlat) !== -1
    && data.payStatusName.toString().toLowerCase().indexOf(searchTerms.payStatusName) !== -1
    && data.reqStatusName.toString().toLowerCase().indexOf(searchTerms.reqStatusName) !== -1
  }
  return filterFunction;
}



popUpOpen(data){

  this.itemOrders = data.itemOrders;
  this.openPop = true;
}

cancel(id){
  this.cancelId = id;
  this.confirm=true;
}

getCancelReason(){
  this.service.getcancellationReason().subscribe(res =>{ 
    this.cancelledReasons = res;
  }) 
}


clearArray2(value){
  this.cancellation=value.name;
}

orderCancellation(){
  this.loader=true;
  var post={
    "cancellationReasons":this.cancellation
  }
  this.service.cancelOrder(this.cancelId,post).subscribe((res:any)=>{
    this.handler.res("Order Cancelled successfully"); 
    this.confirm=false;
    k=1;
    this.getAllOrder(this.date) 
  })
}

Allocations(data,id) {
  if(data.status == 7  && this.auth.checkCapability('FSA')){
    this.allocationOptions = [{ id: 0, name: "Assign Vendor" }]
  }
  if(data.status == 9  && this.auth.checkCapability('FSA')){
    this.allocationOptions = [{ id: 1, name: "Assign Employee" },  { id: 2, name: "Change Vendor" }]
  }
  if(data.status == 12  && this.auth.checkCapability('FSA')){ 
    this.allocationOptions = [{ id: 2, name: "Change Vendor" },{ id: 3, name: "Change Allocation" }]
  }
  if(data.status == 12  && !this.auth.checkCapability('FSA')  && this.auth.checkCapability('SP')){
    this.allocationOptions = [{ id: 3, name: "Change Allocation" }]
  }
  if(data.status == 9 && !this.auth.checkCapability('FSA')   && this.auth.checkCapability('SP')){
    this.allocationOptions = [{ id: 1, name: "Assign Employee" }]
  }
  
  if(data.status == 12 && (this.auth.checkCapability('FSA')  && this.auth.checkCapability('SP'))){
    this.allocationOptions = [{ id: 2, name: "Change Vendor" },{ id: 3, name: "Change Allocation" }]
  }
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.allocationOptions,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.optionName = res.name;
        this.optionId = res.id;     
      if(this.optionId==0){
        this.Vendorselect1(data,id); 
      }
      if(this.optionId==2){
        this.changeVendorselect1(data, id); 
      }
      if(this.optionId==1){
        this.assignVendor1(data,id); 
      }
      if(this.optionId==3 ){
        this.assignVendor(data,id); 
      }
       }
    });
  }
  Vendorselect1(data, id) {
    sessionStorage.setItem('orderId',data.id);
    sessionStorage.setItem('catId', this.serviceCategoryId);
    this.router.navigate(['/purchaseAssign/', +id]);
  }

  changeVendorselect1(data, id) {
    sessionStorage.setItem('orderId',data.id);
    sessionStorage.setItem('catId', this.serviceCategoryId);
    sessionStorage.setItem('vendor',data.vendorId);
    this.router.navigate(['/changePurchaseAssign/', +id]);
  }

  assignVendor1(data, id) {
    sessionStorage.setItem('orderId',data.id);
    sessionStorage.setItem('catId', this.serviceCategoryId);
    sessionStorage.setItem('vendor',data.vendorId)
    this.router.navigate(['/purchaseEmpAssign/', +id]);
  }

  
  assignVendor(data, id) {
    sessionStorage.setItem('orderId',data.id);
    sessionStorage.setItem('catId', this.serviceCategoryId);
    sessionStorage.setItem('employee',data.serviceContractorId);
    sessionStorage.setItem('vendor',data.vendorId)
    this.router.navigate(['/purchaseEmpAssign/', +id]);
  }

  
  viewChange(id) {
    if (id == 1) {
       this.Cview = true;
       this.searchShow = true;  
       this.getAllOrder(this.date);  
      }
    else {
      this.Cview = false;
      this.searchShow = false;
      // this.matTableData(this.date);
     }
  }

  filterReq(){
    this.filterPop = true;
  }

  openBottomSheet() {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.category,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.cateName = res.name;
        this.cateId = res.id; 
      }
    });
  }   

  openBottomSheetstatus() {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.payment,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.paymentName = res.name;
        this.paymentId = res.id;     
      }
    })
  }

  openBottomSheetCheck() {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.statusObj,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.statusName = res.name;
        this.statusId = res.id;
      }
    })
  }

  openBottomSheetOrg(): void {
    const dialogRef = this.bottomSheet.open(BottomSheet,{
      data: this.orgs,
    });
    dialogRef.afterDismissed().subscribe((res:any) => {
      if(res){
        this.loader=true;
        this.orgName = res.name;
            this.orgId=res.id;             
            this.contDrop = true;       
            this.getsc();     
       
      }
      
    });
  }

  openBottomSheetCon(): void {
    if(!this.active1){
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.contractors,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      this.statusName = ""
      this.contractorId = res.userId;
      if(res.lastName)
      this.ContractorName = res.firstName ;
      else
      this.ContractorName = res.firstName;
    });
  }
  }
  
  openBottomSheetCon1(): void {
    if(!this.active1){
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.contractors,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      this.statusName = ""
      this.contractorId = res.userId;
      if(res.lastName)
      this.ContractorName = res.firstName ;
      else
      this.ContractorName = res.firstName;
    });
  }
  }


  cancelFilter() {
    this.loader = true;
    this.statusName = "";
    this.statusId =undefined;
    this.contractorId = undefined;
    this.ContractorName = "";
    this.paymentName = "";
    this.paymentId = undefined;
    this.cateName="";
    this.cateId=undefined;
    this.orgName = "";
    this.orgId = undefined;
    this.filterPop = false;
    this.contDrop = false;
    this.filter = false;
    this.getAllOrder(this.date)
    // this.matTableData(this.date)
  }

  searchfilter() {
    this.filterPop = false;
    this.filter = true;
    var post = [{id:1,val:this.cateId,cateId:true,data:"categoryId"},
      {id:2,val:this.orgId,orgId:true,data:"vendorId"},
      {id:3,val:this.contractorId,contractorId:true,data:"serviceContractorId"},
      {id:4,val:this.statusId,statusId:true,data:"status"},
      {id:5,val:this.paymentId,paymentId:true,data:"paymentStatus"}]
   var y = post.filter(res=>{return res.val != undefined})

   if(y.length == 1){
    this.loader = true;
    this.service.getOrderType1(y[0].data,y[0].val,this.returnDate(this.date)).subscribe((res:any)=>{
        if(res){
      this.orderItems = res; 
      this.orderItems = this.orderItems.filter(res=>{ return (res.status==7 || res.status==2|| res.status==4|| res.status==5|| res.status==6|| res.status==9||res.status==12) && res.orderType==2})
      this.orderItems.map(res => {
        Object.assign(res, { clicked: false })
      }) 
      this.orderItems.map(dat=>{
       this.category.map(dat1=>{
         if(dat.categoryId==dat1.id)
         Object.assign(dat, {categoryName: dat1.name})   
       })
       if(dat.paymtStatus==1)
       Object.assign(dat, {payStatusName: "Not Paid"})
       if(dat.paymtStatus==2)
       Object.assign(dat, {payStatusName: "Paid"})    
       if(dat.status==7)
       Object.assign(dat, {reqStatusName:"Pending"})   
       if(dat.status==2)
       Object.assign(dat, {reqStatusName:"Shipped"})
       if(dat.status==11)
       Object.assign(dat, {reqStatusName:"Partially Delivered"})
       if(dat.status==5)
       Object.assign(dat, {reqStatusName:"Cancelled"})
       if(dat.status==6)
       Object.assign(dat, {reqStatusName:"Returned"})   
       if(dat.status==9)
       Object.assign(dat, {reqStatusName:"Assigned"})
       if(dat.status==4)
       Object.assign(dat, {reqStatusName:"Delivered"})
       if(dat.status==12)
       Object.assign(dat, {reqStatusName:"Allocated"})
       if(dat.appt==true)
       Object.assign(dat, {serviceFlat:dat.flatName})
       if(dat.appt==false)
       Object.assign(dat, {serviceFlat:dat.street})
       if(dat.appt=="" || dat.appt== undefined )
       Object.assign(dat, {serviceFlat:"Not Specified"})
      })
      this.dataSource = new MatTableDataSource(this.orderItems); 
      this.dataSource.filterPredicate = this.createFilter(); 
      this.dataSource.sort = this.sort;
        
      this.loader = false;
     }else{
       this.loader=false;
       this.orderItems=[];
       this.handler.res("No Data Found");
     }   
    }, err => {
      this.loader = false;
      this.filterPop = true;
      this.handler.err(err);
    })
   }
   if(y.length == 2){
    this.loader = true;
    this.service.getOrderType2(y[0].data,y[1].data,y[0].val,y[1].val,this.returnDate(this.date)).subscribe((res:any)=>{
       if(res){
    this.orderItems = res;
    this.orderItems = this.orderItems.filter(res=>{ return (res.status==7 || res.status==2|| res.status==4|| res.status==5|| res.status==6|| res.status==9||res.status==12) && res.orderType==2})
    this.orderItems.map(res => {
      Object.assign(res, { clicked: false })
    }) 
    this.orderItems.map(dat=>{
     this.category.map(dat1=>{
       if(dat.categoryId==dat1.id)
       Object.assign(dat, {categoryName: dat1.name})   
     })
     if(dat.paymtStatus==1)
     Object.assign(dat, {payStatusName: "Not Paid"})
     if(dat.paymtStatus==2)
     Object.assign(dat, {payStatusName: "Paid"})    
     if(dat.status==7)
     Object.assign(dat, {reqStatusName:"Pending"})   
     if(dat.status==2)
     Object.assign(dat, {reqStatusName:"Shipped"})
     if(dat.status==5)
     Object.assign(dat, {reqStatusName:"Cancelled"})
     if(dat.status==6)
     Object.assign(dat, {reqStatusName:"Returned"})   
     if(dat.status==9)
     Object.assign(dat, {reqStatusName:"Assigned"})
     if(dat.status==4)
     Object.assign(dat, {reqStatusName:"Delivered"})
     if(dat.status==12)
     Object.assign(dat, {reqStatusName:"Allocated"})
     if(dat.status==11)
     Object.assign(dat, {reqStatusName:"Partially Delivered"})
     if(dat.appt==true)
     Object.assign(dat, {serviceFlat:dat.flatName})
     if(dat.appt==false)
     Object.assign(dat, {serviceFlat:dat.street})
     if(dat.appt=="" || dat.appt== undefined )
     Object.assign(dat, {serviceFlat:"Not Specified"})
    })
    this.dataSource = new MatTableDataSource(this.orderItems); 
    this.dataSource.filterPredicate = this.createFilter(); 
    this.dataSource.sort = this.sort;
      this.loader = false;
      }else{
        this.loader=false;
       this.orderItems=[];
       this.handler.res("No Data Found");
      }
    }, err => {
      this.loader = false;
      this.filterPop = true;
      this.handler.err(err);
    })
   }
    if(y.length == 3){
      this.loader = true;
      this.service.getOrderType3(y[0].data,y[1].data,y[2].data,y[0].val,y[1].val,y[2].val,this.returnDate(this.date)).subscribe((res:any)=>{
         if(res){
      this.orderItems = res;
      this.orderItems = this.orderItems.filter(res=>{ return (res.status==7 || res.status==2|| res.status==4|| res.status==5|| res.status==6|| res.status==9||res.status==12) && res.orderType==2})
      this.orderItems.map(res => {
        Object.assign(res, { clicked: false })
      }) 
      this.orderItems.map(dat=>{
       this.category.map(dat1=>{
         if(dat.categoryId==dat1.id)
         Object.assign(dat, {categoryName: dat1.name})   
       })
 if(dat.paymtStatus==1)
       Object.assign(dat, {payStatusName: "Not Paid"})
       if(dat.paymtStatus==2)
       Object.assign(dat, {payStatusName: "Paid"})    
       if(dat.status==7)
       Object.assign(dat, {reqStatusName:"Pending"})   
       if(dat.status==2)
       Object.assign(dat, {reqStatusName:"Shipped"})
       if(dat.status==5)
       Object.assign(dat, {reqStatusName:"Cancelled"})
       if(dat.status==6)
       Object.assign(dat, {reqStatusName:"Returned"})   
       if(dat.status==9)
       Object.assign(dat, {reqStatusName:"Assigned"})
       if(dat.status==4)
       Object.assign(dat, {reqStatusName:"Delivered"})
       if(dat.status==12)
       Object.assign(dat, {reqStatusName:"Allocated"})
       if(dat.status==11)
       Object.assign(dat, {reqStatusName:"Partially Delivered"})
       if(dat.appt==true)
       Object.assign(dat, {serviceFlat:dat.flatName})
       if(dat.appt==false)
       Object.assign(dat, {serviceFlat:dat.street})
       if(dat.appt=="" || dat.appt== undefined )
       Object.assign(dat, {serviceFlat:"Not Specified"})
      })
      this.dataSource = new MatTableDataSource(this.orderItems); 
      this.dataSource.filterPredicate = this.createFilter(); 
      this.dataSource.sort = this.sort;
        this.loader = false;
        }else{
          this.loader=false;
       this.orderItems=[];
       this.handler.res("No Data Found");
        }
      }, err => {
        this.loader = false;
        this.filterPop = true;
        this.handler.err(err);
      })
    }
    if(y.length == 4){
      this.loader = true;
      this.service.getOrderType4(y[0].data,y[1].data,y[2].data,y[3].data,y[0].val,y[1].val,y[2].val,y[3].val,this.returnDate(this.date)).subscribe((res:any)=>{
        if(res){
          this.orderItems = res;
          this.orderItems = this.orderItems.filter(res=>{ return (res.status==7 || res.status==2|| res.status==4|| res.status==5|| res.status==6|| res.status==9||res.status==12) && res.orderType==2})
          this.orderItems.map(res => {
            Object.assign(res, { clicked: false })
          }) 
          this.orderItems.map(dat=>{
           this.category.map(dat1=>{
             if(dat.categoryId==dat1.id)
             Object.assign(dat, {categoryName: dat1.name})   
           })
     if(dat.paymtStatus==1)
           Object.assign(dat, {payStatusName: "Not Paid"})
           if(dat.paymtStatus==2)
           Object.assign(dat, {payStatusName: "Paid"})    
           if(dat.status==7)
           Object.assign(dat, {reqStatusName:"Pending"})   
           if(dat.status==2)
           Object.assign(dat, {reqStatusName:"Shipped"})
           if(dat.status==5)
           Object.assign(dat, {reqStatusName:"Cancelled"})
           if(dat.status==6)
           Object.assign(dat, {reqStatusName:"Returned"})   
           if(dat.status==9)
           Object.assign(dat, {reqStatusName:"Assigned"})
           if(dat.status==4)
           Object.assign(dat, {reqStatusName:"Delivered"})
           if(dat.status==11)
           Object.assign(dat, {reqStatusName:"Partially Delivered"})
           if(dat.status==12)
           Object.assign(dat, {reqStatusName:"Allocated"})
           if(dat.appt==true)
           Object.assign(dat, {serviceFlat:dat.flatName})
           if(dat.appt==false)
           Object.assign(dat, {serviceFlat:dat.street})
           if(dat.appt=="" || dat.appt== undefined )
           Object.assign(dat, {serviceFlat:"Not Specified"})
          })
          this.dataSource = new MatTableDataSource(this.orderItems); 
          this.dataSource.filterPredicate = this.createFilter(); 
          this.dataSource.sort = this.sort;
            this.loader = false;
            }else{
              this.loader=false;
           this.orderItems=[];
           this.handler.res("No Data Found");
            }
      }, err => {
        this.loader = false;
        this.filterPop = true;
        this.handler.err(err);
      })
    }
    if(y.length == 5){
      this.loader = true;
      this.service.getOrderType5(y[0].data,y[1].data,y[2].data,y[3].data,y[4].data,y[0].val,y[1].val,y[2].val,y[3].val,y[4].val,this.returnDate(this.date)).subscribe((res:any)=>{
        if(res){
          this.orderItems = res;
          this.orderItems = this.orderItems.filter(res=>{ return (res.status==7 || res.status==2|| res.status==4|| res.status==5|| res.status==6|| res.status==9||res.status==12) && res.orderType==2})
          this.orderItems.map(res => {
            Object.assign(res, { clicked: false })
          }) 
          this.orderItems.map(dat=>{
           this.category.map(dat1=>{
             if(dat.categoryId==dat1.id)
             Object.assign(dat, {categoryName: dat1.name})   
           })
     if(dat.paymtStatus==1)
           Object.assign(dat, {payStatusName: "Not Paid"})
           if(dat.paymtStatus==2)
           Object.assign(dat, {payStatusName: "Paid"})    
           if(dat.status==7)
           Object.assign(dat, {reqStatusName:"Pending"})   
           if(dat.status==2)
           Object.assign(dat, {reqStatusName:"Shipped"})
           if(dat.status==5)
           Object.assign(dat, {reqStatusName:"Cancelled"})
           if(dat.status==6)
           Object.assign(dat, {reqStatusName:"Returned"})   
           if(dat.status==9)
           Object.assign(dat, {reqStatusName:"Assigned"})
           if(dat.status==4)
           Object.assign(dat, {reqStatusName:"Delivered"})
           if(dat.status==12)
           Object.assign(dat, {reqStatusName:"Allocated"})
           if(dat.status==11)
           Object.assign(dat, {reqStatusName:"Partially Delivered"})
           if(dat.appt==true)
           Object.assign(dat, {serviceFlat:dat.flatName})
           if(dat.appt==false)
           Object.assign(dat, {serviceFlat:dat.street})
           if(dat.appt=="" || dat.appt== undefined )
           Object.assign(dat, {serviceFlat:"Not Specified"})
          })
          this.dataSource = new MatTableDataSource(this.orderItems); 
          this.dataSource.filterPredicate = this.createFilter(); 
          this.dataSource.sort = this.sort;
            this.loader = false;
            }else{
              this.loader=false;
           this.orderItems=[];
           this.handler.res("No Data Found");
            }
      }, err => {
        this.loader = false;
        this.filterPop = true;
        this.handler.err(err);
      })
    }   
  }

  exportAsXLSX(){
    this.orderItems.map(res =>{
      if(res.paymtStatus==1)
      Object.assign(res, {payStatusName: "Not Paid"})
      if(res.paymtStatus==2)
      Object.assign(res, {payStatusName: "Paid"})
       
      this.excelDataAll.push({
        OrderId:res.id,CustomerName:res.custName,FlatName:res.flatName,Street:res.street,Region:res.delRegion,
        Categories:res.categoryName,Payment:res.payStatusName
      })
    })
    this.excelService.exportAsExcelFile(this.excelDataAll, 'Order Details');
   
  this.excelDataAll=[]
  }

  notify(){
    // this.send = true;
    // this.check = true;
    this.orderItems.map(res=>
      res.clicked=false)

    if(!this.send){
      this.send = true;
    }else{
      this.send = false;
    }

    if(!this.check){
      this.check = true;
    }else{
      this.check = false;
    }
  }

  triggerChange(data) {
    if (this.send) {
      data.clicked = !data.clicked  
      this.notifyItems = this.orderItems.filter(res => res.clicked)
    }

  }

  sendNot(){ 
    this.notifyItems.map(res=>{
      this.loader = true;
      var post={
        "notifications":this.message
      }
      this.service.sendNotification(res.id,post).subscribe((res1:any)=>{
       res.clicked = false;
       this.send = false;
       this.openPopUp = false;
       this.loader = false;
       this.check = false;
      },err=>{
        res.clicked = false;
        this.handler.err(err)
        this.send = false;
        this.openPopUp = false;
        this.loader = false;
        this.check = false;
      })
    })
  }

  mess(){
    this.service.getPaymentRemainderMsg().subscribe((res:any)=>{
      this.message=res.notifications;
    })  
    this.openPopUp = true;
  }

  clear(){
    this.search="";
  }


  ordersByPage($event,date){
    if(!this.filter){
      this.clear();
      this.service.getAllOrderByType(this.returnDate(date),k).subscribe((res: any) => {
        if(res){
           res.map(dat=>{
          this.orderItems.push(dat);
        })
          this.orderItems = this.orderItems.filter(res=>{ return (res.status==7 || res.status==2|| res.status==4|| res.status==5|| res.status==6|| res.status==9||res.status==12) && res.orderType==2})
          this.orderItems.map(res => {
            Object.assign(res, { clicked: false })
          }) 
          this.orderItems.map(dat=>{
           this.category.map(dat1=>{
             if(dat.categoryId==dat1.id)
             Object.assign(dat, {categoryName: dat1.name})   
           })
     if(dat.paymtStatus==1)
           Object.assign(dat, {payStatusName: "Not Paid"})
           if(dat.paymtStatus==2)
           Object.assign(dat, {payStatusName: "Paid"})    
           if(dat.status==7)
           Object.assign(dat, {reqStatusName:"Pending"})   
           if(dat.status==2)
           Object.assign(dat, {reqStatusName:"Shipped"})
           if(dat.status==5)
           Object.assign(dat, {reqStatusName:"Cancelled"})
           if(dat.status==6)
           Object.assign(dat, {reqStatusName:"Returned"})   
           if(dat.status==9)
           Object.assign(dat, {reqStatusName:"Assigned"})
           if(dat.status==4)
           Object.assign(dat, {reqStatusName:"Delivered"})
           if(dat.status==12)
           Object.assign(dat, {reqStatusName:"Allocated"})
           if(dat.status==11)
           Object.assign(dat, {reqStatusName:"Partially Delivered"})
           if(dat.appt==true)
           Object.assign(dat, {serviceFlat:dat.flatName})
           if(dat.appt==false)
           Object.assign(dat, {serviceFlat:dat.street})
           if(dat.appt=="" || dat.appt== undefined )
           Object.assign(dat, {serviceFlat:"Not Specified"})
          })
          console.log(this.orderItems)
          k++;
          this.dataSource = new MatTableDataSource(this.orderItems); 
          this.dataSource.filterPredicate = this.createFilter(); 
          this.dataSource.sort = this.sort;
            this.loader = false;
            }else{
              this.loader=false;
              console.log('1')
           this.orderItems=[];
           this.handler.res("No Data Found");
            }  
      }) 
    }
  
    }
    pay(id){
      this.router.navigate(['/record-pay/', +id]); 
    }

    refreshData(event){ 
      this.ionViewWillEnter();  
  }



    checkPreview(){
      this.openSlot = true;
      this.slotClicked =false;
      var post ={
        "targetCenterId": this.Oid,
        "targetSource": this.Oid,
        "schElements": [
            1
        ],
        "requestDate": this.fDate,
        "status": [
            "SlotsAvailable"
        ],
        "independentEntities": true,
        "slotDuration": 15
    }
      this.service.getTimeSlots(this.slotDate,post).subscribe((res: any) => {
        if (res){
          this.availableSlots = res;
          this.availSlot = true;
          this.slotClicked = true;
        }else{
           this.handler.res("No Available Slots");
           this.availSlot = false;
           this.slotClicked = true;
        }
        
      })
    }

    setTime(data){
      this.time = data.startTime;
      this.endTime = data.endTime;
      this.slot = data;
      this.slotClicked = false;
      this.openSlot = false;
    }

    reschedule(){
      var post={
        "apptDate":this.fDate,
    "apptTime": this.time,
    "apptEndTime": this.slot.endTime, 
        "requestDates": [
          {
            "apptDate": this.fDate,  
            "apptTime":this.time,
            "apptEndTime": this.slot.endTime,        
            "status": 1
          }],
      }  
      this.service.rescheduleOrder(this.orderId,post).subscribe((res:any)=>{
      this.handler.res('Order Rescheduled Successfully!!')
      this.rescheduleOrd=false;
      this.getAllOrder(this.date);
      })
    }
    startDate(){
      this.fDate=this.returnDate(this.startdate);
      this.slotDate=this.returnDate1(this.startdate);
      this.time = "Time"
    }
}
